/* Native IDs/prices and Shopify automatic discounts remain authoritative. */
(() => {
  if (customElements.get('ona-purchase')) return;
  const displayColor = value => ({'Burgundy Color':'Burgundy',Sagegreen:'Sage Green'}[value] || value);
  class OnaPurchase extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const {signal} = this.controller;
      this.info = this.closest('product-info');
      this.form = document.getElementById(this.dataset.formId);
      this.quantity = this.info?.querySelector(`input[name="quantity"][form="${this.dataset.formId}"]`);
      if (!this.form || !this.quantity) return;
      this.variants = JSON.parse(this.querySelector('[data-purchase-variants]').textContent);
      this.pack = Number(this.dataset.pack);
      this.pairOffer = this.dataset.pairOffer === 'true';
      const requestedQuantity=Number(new URLSearchParams(location.search).get('quantity'));
      if(Number.isSafeInteger(requestedQuantity) && requestedQuantity>0 && requestedQuantity<=1000){this.quantity.value=String(Math.max(Number(this.quantity.min)||1,Math.min(Number(this.quantity.max)||Infinity,requestedQuantity)));}
      this.wantedQuantity = this.quantity.value;
      const quantityBlock=this.quantity.closest('.product-form__quantity');
      if (this.pairOffer && this.querySelector('.ona-purchase__offers')) {
        if (quantityBlock) {
          const more=document.createElement('details');
          more.className='ona-purchase__more';
          const summary=document.createElement('summary');summary.textContent='More than 3 pairs';
          more.append(summary,quantityBlock);
          this.querySelector('.ona-purchase__offers').after(more);
        }
      }
      if (this.dataset.groupOptions === 'false' && quantityBlock) {
        this.prepend(quantityBlock);
        const unitLabel=this.pack===2 ? 'Pairs' : 'Panels';
        const label=quantityBlock.querySelector('.quantity__label > span');
        if (label) label.textContent=unitLabel;
        this.quantity.setAttribute('aria-label',unitLabel);
      }
      this.nativeAdd = this.form.querySelector('[name="add"]');
      this.buy = this.form.querySelector('[data-ona-buy-now]');
      this.money = value => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency:this.dataset.currency || 'USD'}).format(value/100);
      this.addEventListener('change', event => {
        if (!event.target.matches('input[type="radio"]')) return;
        this.quantity.value = event.target.value;
        this.wantedQuantity = event.target.value;
        this.quantity.dispatchEvent(new Event('change', {bubbles:true}));
        this.update();
      }, {signal});
      this.quantity.addEventListener('input', () => {this.wantedQuantity=this.quantity.value;this.update();}, {signal});
      this.quantity.addEventListener('change', () => {this.wantedQuantity=this.quantity.value;this.update();}, {signal});
      this.buy?.addEventListener('click', () => this.checkout(), {signal});
      this.selectThree = [...this.info.querySelectorAll('[data-ona-select-three]')].find(button => button.dataset.formId === this.dataset.formId);
      this.selectThree?.addEventListener('click', () => {
        if(this.pending || this.nativeAdd?.disabled)return;
        this.quantity.value='3';this.wantedQuantity='3';this.quantity.dispatchEvent(new Event('change',{bubbles:true}));this.update();
      }, {signal});
      this.form.addEventListener('submit', event => {
        if (this.pending) {event.preventDefault(); event.stopImmediatePropagation();}
      }, {capture:true,signal});
      this.observer = new MutationObserver(() => this.update());
      this.observer.observe(this.form.closest('product-form') || this.form,{childList:true,subtree:true,attributes:true,attributeFilter:['value','disabled','aria-disabled','class','hidden']});
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, event => {
          if (event.data?.sectionId === (this.info.dataset.originalSection || this.info.dataset.section)) this.restoreQuantity();
        });
        this.unsubscribeQuantity = subscribe(PUB_SUB_EVENTS.quantityUpdate, () => queueMicrotask(() => this.restoreQuantity()));
      }
      if (!this.closest('ona-quick-shop,quick-add-modal,[role="dialog"]')) {
        this.createSticky(signal);
        this.fitDesktopPanel(signal);
        this.refreshCart();
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) this.unsubscribeCart=subscribe(PUB_SUB_EVENTS.cartUpdate,()=>this.refreshCart());
      }
      window.addEventListener('pageshow', event => {
        if (event.persisted) {this.pending=false;this.text(this.buy,'Buy it now');this.update();}
        this.refreshCart();
      }, {signal});
      this.update();
    }
    fitDesktopPanel(signal) {
      this.panel=this.info.querySelector('.product__info-container');
      if (!this.panel) return;
      const header=document.querySelector('.ona-source-header')?.closest('.shopify-section');
      const fit=()=>{
        this.panelSizeFrame=null;
        if (!this.panel.isConnected) return;
        if (!matchMedia('(min-width:990px)').matches) {
          this.panel.style.removeProperty('--ona-panel-top');
          this.panel.style.removeProperty('position');
          return;
        }
        const headerBottom=document.documentElement.dataset.onaNav === 'down' ? 0 : Math.max(0,header?.offsetHeight || 0);
        const upperEdge=headerBottom+16;
        const available=window.innerHeight-upperEdge-16;
        const panelHeight=this.panel.getBoundingClientRect().height;
        // Center panels that fit. Taller panels scroll until their bottom is visible,
        // then stick there so every control stays reachable without an inner scrollbar.
        this.panel.style.removeProperty('position');
        const top=panelHeight>available
          ? window.innerHeight-panelHeight-16
          : upperEdge+Math.floor((available-panelHeight)/2);
        const value=`${top}px`;
        if (this.panel.style.getPropertyValue('--ona-panel-top')!==value) this.panel.style.setProperty('--ona-panel-top',value);
      };
      const schedule=()=>{if(this.panelSizeFrame==null)this.panelSizeFrame=requestAnimationFrame(fit);};
      window.addEventListener('resize',schedule,{passive:true,signal});
      window.addEventListener('scroll',schedule,{passive:true,signal});
      this.panelResize=new ResizeObserver(schedule);
      this.panelResize.observe(this.panel);
      if (header) {
        this.headerResize=new ResizeObserver(schedule);
        this.headerResize.observe(header);
      }
      schedule();
    }
    variant() {return this.variants.find(v => String(v.id) === this.form.querySelector('[name="id"]')?.value);}
    restoreQuantity() {
      this.quantity.value=Math.max(Number(this.quantity.min)||1,Math.min(Number(this.quantity.max)||Infinity,Number(this.wantedQuantity)||1));
      this.update();
    }
    // Offers stack: Buy 2, get 1 free first, then an extra 20% off the rest at 4+ eligible items.
    saving(q) {
      if (!this.pairOffer) return 0;
      if (this.pack === 1 && q === 2) return 4900;
      const price=this.variant()?.price || 0;
      const free=Math.floor(q/3)*price;
      return free+(q >= 4 ? Math.round((q*price-free)*0.2) : 0);
    }
    text(node,value) {if (node && node.textContent !== value) node.textContent=value;}
    update() {
      if (this.dataset.groupOptions === 'false') {
        const label=this.quantity.closest('.product-form__quantity')?.querySelector('.quantity__label > span');
        this.text(label,this.pack===2 ? 'Pairs' : 'Panels');
      }
      const variant=this.variant();
      const q=Math.max(1,Number.parseInt(this.quantity.value,10)||1);
      const valid=variant?.available && !this.form.querySelector('[name="id"]')?.disabled && !this.nativeAdd?.disabled;
      const busy=this.pending || this.nativeAdd?.getAttribute('aria-disabled') === 'true' || this.nativeAdd?.classList.contains('loading');
      // This button can live inside the observed product form. Rewriting an
      // existing disabled attribute queues another observer callback indefinitely.
      const selectThreeDisabled=!valid || Boolean(busy) || (Number(this.quantity.max)>0 && Number(this.quantity.max)<3);
      if(this.selectThree && this.selectThree.disabled!==selectThreeDisabled)this.selectThree.disabled=selectThreeDisabled;
      this.querySelectorAll('[data-offer-price]').forEach(node => {
        const n=Number(node.dataset.offerPrice);
        this.text(node,variant ? this.money(variant.price*n-this.saving(n)) : 'Unavailable');
      });
      this.querySelectorAll('input[type="radio"]').forEach(input => {input.checked=Number(input.value)===q;if(input.disabled!==(!valid || Boolean(busy)))input.disabled=!valid || Boolean(busy);});
      this.text(this.querySelector('[data-purchase-contents]'),this.dataset.groupOptions==='false' ? (this.pack===2 ? `${q*2} panels` : `${q} ${q===1?'panel':'panels'}`) : (this.pack===2 ? `${q} ${q===1?'pair':'pairs'} · ${q*2} panels` : `${q} wide ${q===1?'panel':'panels'}`));
      const compare=this.querySelector('[data-purchase-compare]');
      const comparePrice=Number(variant?.compare_at_price);
      const hasCompare=variant && comparePrice>variant.price;
      if (compare) {
        compare.hidden=!hasCompare;
        this.text(compare,hasCompare ? this.money(comparePrice*q) : '');
      }
      this.text(this.querySelector('[data-purchase-total]'),variant ? this.money(variant.price*q-this.saving(q)) : 'Unavailable');
      if (this.buy && this.buy.disabled !== (!valid || Boolean(busy))) this.buy.disabled=!valid || Boolean(busy);
      if (this.sticky) {
        this.sticky.querySelectorAll('[data-sticky-add],[data-sticky-edit]').forEach(button => {
          button.disabled=button.hasAttribute('data-sticky-edit') ? Boolean(busy) : !valid || Boolean(busy);
        });
        this.sticky.setAttribute('aria-busy',String(Boolean(busy)));
        this.text(this.sticky.querySelector('[data-sticky-add]'),busy && !this.pending ? 'Adding…' : variant?.available ? 'Add to cart' : 'Unavailable');
        const error=this.form.closest('product-form')?.querySelector('.product-form__error-message-wrapper');
        const errorText=error && !error.hidden ? error.querySelector('.product-form__error-message')?.textContent.trim() : '';
        this.text(this.sticky.querySelector('[data-sticky-error]'),errorText || '');
        this.text(this.sticky.querySelector('[data-sticky-price]'),variant ? this.money(variant.price*q-this.saving(q)) : 'Unavailable');
        this.text(this.sticky.querySelector('[data-sticky-selection]'),variant ? `${displayColor(variant.option1)} · ${variant.option2} · ${q} ${this.pack===2?(q===1?'pair':'pairs'):(q===1?'panel':'panels')}` : 'Choose an available size');
      }
    }
    createSticky(signal) {
      this.sticky=document.createElement('section');
      this.sticky.className='ona-purchase-sticky';
      this.sticky.setAttribute('aria-label','Your curtain selection');
      this.sticky.innerHTML='<div class="ona-purchase-sticky__row"><button type="button" class="ona-purchase-sticky__edit" data-sticky-edit><span class="visually-hidden">Edit selection: </span><strong data-sticky-price></strong><small><span data-sticky-selection></span><svg class="ona-purchase-sticky__pencil" width="13" height="13" viewBox="0 0 18 18" fill="none" aria-hidden="true" focusable="false"><path d="M12.4 2.9a1.4 1.4 0 0 1 2 2L7 12.3l-2.7.7.7-2.7z" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/><path d="M11.3 4l2.7 2.7" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/></svg></small></button><button type="button" class="button button--primary" data-sticky-add>Add to cart</button></div><p class="ona-purchase-sticky__error" data-sticky-error role="status" aria-live="polite"></p>';
      this.sticky.querySelector('[data-sticky-add]').addEventListener('click',()=>{
        if(!this.nativeAdd.disabled && !this.pending && this.quantity.reportValidity()) this.nativeAdd.click();
      },{signal});
      this.sticky.querySelector('[data-sticky-edit]').addEventListener('click',()=>this.editSelection(),{signal});
      document.body.append(this.sticky);
      this.stickyResize=new ResizeObserver(()=>{
        document.body.style.setProperty('--ona-purchase-bar-height',`${Math.ceil(this.sticky.getBoundingClientRect().height)}px`);
      });
      this.stickyResize.observe(this.sticky);
    }
    editSelection() {
      const target=this.info.querySelector('[id^="OnaFormat-"]')?.closest('.product-form__input') || this.info.querySelector('ona-type-selectors') || this.info.querySelector('variant-selects');
      if (!target) return;
      const control=[...target.querySelectorAll('select,button,input,a[href]')].find(node=>!node.disabled && node.getClientRects().length);
      control?.focus({preventScroll:true});
      const header=document.querySelector('.shopify-section-header,sticky-header,header');
      const headerRect=header?.getBoundingClientRect();
      const offset=headerRect && headerRect.top<=0 && headerRect.bottom>0 ? headerRect.bottom+16 : 24;
      window.scrollTo({top:Math.max(0,window.scrollY+target.getBoundingClientRect().top-offset),behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});
    }
    // Progress toward the stacked offers. Shopify still applies the real discounts.
    offerLine(q) {
      if (!this.pairOffer) return '';
      const items=(this.cartCount || 0)+q;
      if (items % 3 === 2) return 'One more and every 3rd is free';
      if (items < 4) return `${4-items} more unlocks an extra 20% off`;
      return 'Extra 20% off 4+ applied in your bag';
    }
    openBag() {
      // With a bag already built, go straight to payment; with an empty bag, buy this selection.
      if (this.cartCount>0) {window.location.assign((window.Shopify?.routes?.root || '/')+'checkout');return;}
      this.checkout();
    }
    refreshCart() {
      fetch((window.Shopify?.routes?.root || '/')+'cart.js',{headers:{Accept:'application/json'}})
        .then(response => response.ok ? response.json() : null)
        .then(cart => {
          if (!cart) return;
          if (this.cartCount === cart.item_count && this.cartTotal === cart.total_price) return;
          this.cartCount=cart.item_count; this.cartTotal=cart.total_price; this.update();
        })
        .catch(() => {});
    }
    async checkout() {
      if (!this.buy || this.buy.disabled || this.nativeAdd.disabled || this.nativeAdd.getAttribute('aria-disabled') === 'true' || this.pending || !this.quantity.reportValidity()) return;
      this.pending=true;this.update();this.text(this.buy,'Opening…');
      const wrapper=this.form.closest('product-form')?.querySelector('.product-form__error-message-wrapper');
      const message=wrapper?.querySelector('.product-form__error-message');
      if(wrapper)wrapper.hidden=true;
      try {
        const body=new FormData(this.form);
        // Radio offers live inside the product form, but are presentation-only.
        [...body.keys()].filter(key=>key.startsWith('ona-pairs-')).forEach(key=>body.delete(key));
        const response=await fetch(window.routes?.cart_add_url || '/cart/add.js',{method:'POST',body,headers:{Accept:'application/json','X-Requested-With':'XMLHttpRequest'}});
        const result=await response.json();
        if(!response.ok || result.status)throw new Error(result.description || 'This selection could not be added. Please review your bag.');
        // Shopify applies Buy 2 get 1 free and the 4+ bonus automatically, so there is
        // nothing to choose in the cart first — go straight to payment.
        window.location.assign((window.Shopify?.routes?.root || '/')+'checkout');
      } catch(error) {
        if(wrapper){wrapper.hidden=false;this.text(message,error instanceof TypeError?'Connection interrupted. Check your bag before trying again.':error.message);}
        this.pending=false;this.text(this.buy,'Buy it now');this.update();
      }
    }
    disconnectedCallback() {this.unsubscribeCart?.();this.controller?.abort();this.observer?.disconnect();this.stickyResize?.disconnect();this.panelResize?.disconnect();this.headerResize?.disconnect();if(this.panelSizeFrame!=null)cancelAnimationFrame(this.panelSizeFrame);this.panel?.style.removeProperty('--ona-panel-top');this.panel?.style.removeProperty('position');this.unsubscribe?.();this.unsubscribeQuantity?.();this.sticky?.remove();if(!document.querySelector('.ona-purchase-sticky'))document.body.style.removeProperty('--ona-purchase-bar-height');this.controller=null;}
  }
  customElements.define('ona-purchase',OnaPurchase);
})();
